import {
  Box,
  BreadcrumbGroup,
  FormField,
  Header,
  Select,
  SpaceBetween,
  Container,
  Button,
} from '@amzn/awsui-components-react-v3';
import React, { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import SiteInput from '../../components/SiteInput';
import { containerMoveFlag } from '../../utils/featureFlags';

/**
 * Component for Landing Page
 * @component
 * @returns {ReactElement}
 */
const InventoryMove = (): ReactElement => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = React.useState({
    label: 'Container',
    value: 'container',
  });
  const showContainerMove = containerMoveFlag();
  const [selectedValue, setSelectedValue] = useState<string>('container');
  const setLocation = () => {
    // getting locationID to get sites
    const loc = localStorage.getItem('siteId');
    if (loc) {
      return JSON.parse(loc).locationId;
    }
    return '';
  };

  const breadcrumbs = [
    {
      text: t('breadcrumb.home'),
      href: '/',
    },
    {
      text: t('breadcrumb.inventory-management'),
      href: '/assets-inventory/',
    },
    {
      text: t('breadcrumb.inventory-move'),
      href: '/assets-inventory/move',
    },
  ];

  const handleMoveTypeChange = (obj: any) => {
    setSelectedOption(obj);
    setSelectedValue(obj?.value || null);
  };

  const history = useHistory();
  const handleNext = () => {
    if (selectedValue === 'container') {
      history.push('/move/container');
    }
  };

  const createDropDown = (option: any, onchange: any, options: any, name: any) => {
    return (
      <Select
        selectedOption={option}
        onChange={({ detail }) => onchange(detail.selectedOption)}
        options={options}
        placeholder="Choose"
        selectedAriaLabel="Selected"
        empty="No options"
      />
    );
  };

  return (
    <div key="landingForm" className="formWidth">
      <SpaceBetween direction="vertical" size="s">
        <BreadcrumbGroup items={breadcrumbs} />

        <SpaceBetween direction="vertical" size="xs">
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <SiteInput onSiteChange={setLocation} />
            </SpaceBetween>
          </Box>

          {showContainerMove && (
            <Container header={<Header variant="h2">Inventory Move</Header>}>
              <SpaceBetween direction="vertical" size="l">
                <FormField label="Move Type">
                  <div className="dropDownStyle">
                    {createDropDown(selectedOption, handleMoveTypeChange, [], 'Move Type')}
                  </div>
                </FormField>
              </SpaceBetween>

              <Box float="right">
                <SpaceBetween direction="horizontal" size="xs">
                  <Button href="/" variant="link">
                    {t('Return Home')}
                  </Button>
                  <Button
                    data-test-id="next"
                    disabled={selectedValue === ''}
                    variant="primary"
                    onClick={handleNext}
                  >
                    {t('Next')}
                  </Button>
                </SpaceBetween>
              </Box>
            </Container>
          )}
        </SpaceBetween>
      </SpaceBetween>
    </div>
  );
};

export default InventoryMove;
